module.exports = __webpack_public_path__ + "img/0Q3A2626_FoamcoreMatted.2b467952.jpg";